module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABM0lEQVRYhe2XXRKCMAyEs473gps13AxOFl+gjW2wqbTy4s4wMIGyn82PClJiZqGOCiHAigMp/DQWdTFfloUAiIiYEIceXdxOxMwE4OOuDgWY57kKUaSgp6ZpIqK0E1Y6hgJ4IIYC6GpXMSGieGNYDYQQSETejnVdi+eGFqFHtwN0qYE81yL+gXoJwCoyHfeAVFNQMyEiija8H5W1TQD5ywDY5lpsBb8E0NtY5Nrvc6p6DQBEex+/hxNMvOLs7JC/DQ9DIF4v2lyrK4D+5FkKko/ERxs60AcQPY+3Fy6lYwtEQxekc9qI62Xo6IISohTifUfrtwGkqWZlwC7DFgj3KAZAIpLNAt7hzlv0MsDHQXRSbUfcA+LegZZvuJY1t/8e+AP8AYou2LbtpwB5o3b9e+7xfQELe3md15VQhwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/WINFILE_32.png
// module id = 109
// module chunks = 0